// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatwidget-inline-1 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.chatwidget-inline-2 {
  padding: 12px 22px 20px;
}

.chatwidget-dyn-1 {
  background: var(--chatwidget-1-background);
  border-color: var(--chatwidget-1-border-color);
  color: var(--chatwidget-1-color);
}

.chat-empty {
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  padding: 12px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/ChatWidget.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".chatwidget-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chatwidget-inline-2 {\n  padding: 12px 22px 20px;\n}\n\n.chatwidget-dyn-1 {\n  background: var(--chatwidget-1-background);\n  border-color: var(--chatwidget-1-border-color);\n  color: var(--chatwidget-1-color);\n}\n\n.chat-empty {\n  color: #94a3b8;\n  font-size: 12px;\n  text-align: center;\n  padding: 12px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
